// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"companyReportSection_wrapper__1BBYC","companyNameHeader":"companyReportSection_companyNameHeader__15AZ0"};